export function getShareTheLovePrepopulateData(data) {
  return {
    distinctId: data.id,
    entityId: data.currentEntity.id,
    fullName: data.data.attributes.full_name,
    tradingName: data.currentEntity.attributes.trading_name,
  };
}
